import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@mui/material/Grid';

function ProductImageSection({
	theme,
	imageSrc = '',
	hasDescriptionAndDesign = false,
}) {
	if (!imageSrc) {
		return null;
	}

	return (
		<Grid
			item
			style={{
				marginLeft: theme.spacing(6),
				marginBottom: hasDescriptionAndDesign ? theme.spacing(-7) : '',
			}}
			role="img"
			aria-label="product drawing"
		>
			<img alt="product drawing" src={imageSrc} />
		</Grid>
	);
}

ProductImageSection.propTypes = {
	hasDescriptionAndDesign: PropTypes.bool,
	imageSrc: PropTypes.string,
	theme: PropTypes.object.isRequired,
};

export default ProductImageSection;
